class TaskModel extends App.Models.BaseModel {
    modelUrl = 'Task';

    constructor() {
        super();

        this.id = null;
        this.title = null;
        this.description = null;
        this.dueDate = null;
        this.createdAt = null;
        this.taskStatus = null;
        this.modifiedAt = null;
        this.mainFolder = null;
        this.mainIdentifier = null;
        this.drivers = [];
        this.equipments = [];
        this.routes = [];
        this.locations = [];
        this.events = [];
        this.anotherTask = [];
    }
}

App.Models.Task = TaskModel;
